// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { TracingAreaRoutes } from '@backoffice-frontend/tracing-api'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { TracingAreaId } from './TracingAreaId'

import { TracingAreaNavigation } from './TracingAreaNavigation'

const LazyTracingComponent = lazy(() => import('./TracingArea'))

const TracingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyTracingComponent />
  </SuspenseLoadingWrapper>
)

export const TracingArea = {
  id: TracingAreaId,
  requiredRight: BoumRight.AREA_TRACING,
  NavigationComponent: TracingAreaNavigation,
  route: {
    path: TracingAreaRoutes.route,
    component: TracingComponent,
  },
}
